import { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import { business } from '../../data/business';
import { Arrow } from './icons';

/** The external order site. Every Order button on the page goes through this. */
export const OrderLink = ({
  className = 'sp-btn sp-btn--primary',
  children = 'Order Online',
  label,
}: {
  className?: string;
  children?: ReactNode;
  label?: string;
}) => (
  <a
    className={className}
    href={business.orderUrl}
    target="_blank"
    rel="noopener noreferrer"
    data-track="order_click"
    aria-label={label}
  >
    {children}
  </a>
);

export const CallLink = ({ className, children }: { className?: string; children?: ReactNode }) => (
  <a className={className} href={business.telephoneHref} data-track="call_click">
    {children ?? business.telephoneDisplay}
  </a>
);

/** Hairline-underlined text link with the drawn arrow. Internal paths use the router. */
export const ArrowLink = ({
  to,
  children,
  external,
  label,
  track,
}: {
  to: string;
  children: ReactNode;
  external?: boolean;
  label?: string;
  track?: string;
}) => {
  const inner = (
    <>
      <span>{children}</span>
      <Arrow />
    </>
  );
  if (external || to.startsWith('#') || to.startsWith('tel:') || to.endsWith('.html')) {
    return (
      <a
        className="sp-arrow-link"
        href={to}
        aria-label={label}
        data-track={track}
        {...(external ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
      >
        {inner}
      </a>
    );
  }
  return (
    <Link className="sp-arrow-link" to={to} aria-label={label} data-track={track}>
      {inner}
    </Link>
  );
};
